'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

// import labSetupTools from 'hublabs-experiments/setup/setupTools';


var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _immutable = require('immutable');

var _HublessAuthDAO = require('../data/HublessAuthDAO');

var _UsageTrackerContainer = require('../tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HublessAuth = function () {
  function HublessAuth() {
    _classCallCheck(this, HublessAuth);

    this.data = {
      user: null,
      userId: null
    };
    this.initialized = false;
  }

  _createClass(HublessAuth, [{
    key: 'init',
    value: function init() {
      var _this = this;

      if (this.initialized) {
        return _q2.default.Promise.resolve(this.data);
      }

      return (0, _HublessAuthDAO.getHublessUserInfo)().then(function (response) {
        return _this.setAuth(response);
      });
    }
  }, {
    key: 'get',
    value: function get() {
      return _extends({}, this.data, {
        initialized: this.initialized
      });
    }
  }, {
    key: 'setAuth',
    value: function setAuth() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var user = payload.user;
      this.initialized = true;

      // labSetupTools.registerUser(this.data.portalId); TODO: use userId?

      var id = user.id,
          rest = _objectWithoutProperties(user, ['id']);

      var email = user.emails ? user.emails[0] : null;
      rest.email = email;

      this.data = {
        userId: id,
        user: (0, _immutable.fromJS)(rest)
      };

      // When a user is properly authed, re-initialize tracker
      var updatedUsageTrackerConfig = {
        namespace: 'signup',
        email: email,
        hstc: _UsageTrackerContainer.getTrackerHstc,
        userId: id
      };
      _UsageTrackerContainer2.default.setProperties(updatedUsageTrackerConfig);
      return this.data;
    }
  }]);

  return HublessAuth;
}();

exports.default = new HublessAuth();
module.exports = exports['default'];